import { render } from "./RecommendPointRank120.vue?vue&type=template&id=aa4c2cea&scoped=true"
import script from "./RecommendPointRank120.vue?vue&type=script&lang=js"
export * from "./RecommendPointRank120.vue?vue&type=script&lang=js"

import "./RecommendPointRank120.vue?vue&type=style&index=0&id=aa4c2cea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa4c2cea"]])

export default __exports__